import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseButton } from '../components/base-button/Component.js';

var defaultColors = {"primary":"button__primary_15fcc","loader":"button__loader_15fcc","secondary":"button__secondary_15fcc","text":"button__text_15fcc","ghost":"button__ghost_15fcc","component":"button__component_15fcc","loading":"button__loading_15fcc","outlined":"button__outlined_15fcc","tertiary":"button__tertiary_15fcc","transparent":"button__transparent_15fcc","link":"button__link_15fcc"};
require('./default.desktop.css')

var styles = {"size-32":"button__size-32_19gim","size-40":"button__size-40_19gim","size-48":"button__size-48_19gim","size-56":"button__size-56_19gim","size-64":"button__size-64_19gim","size-72":"button__size-72_19gim"};
require('./desktop.css')

var invertedColors = {"primary":"button__primary_zb40k","loader":"button__loader_zb40k","secondary":"button__secondary_zb40k","text":"button__text_zb40k","ghost":"button__ghost_zb40k","component":"button__component_zb40k","loading":"button__loading_zb40k","outlined":"button__outlined_zb40k","tertiary":"button__tertiary_zb40k","transparent":"button__transparent_zb40k","link":"button__link_zb40k"};
require('./inverted.desktop.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var ButtonDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseButton, __assign({}, restProps, { ref: ref, styles: styles, colorStylesMap: colorStyles }))); });

export { ButtonDesktop };
